/**
 * Lista de palabras prohibidas para validación de nombres y apellidos
 * Provista por el área de negocio
 */

export const PROHIBITED_WORDS = [
  // Testing / placeholders
  'test',
  'testing',
  'prueba',
  'pruebas',
  'demo',
  'demostracion',
  'demostración',
  'sample',
  'mock',
  'dummy',
  'training',
  'train',
  'ejemplo',
  'example',
  'quote',
  'cotizacion',
  'cotización',
  'presupuesto',
  'estimacion',
  'estimación',
  'name',
  'nombre',
  'pax',
  'passenger',
  'cliente',
  'client',
  'booking',
  'reserva',
  'res',
  'hold',
  'bloqueo',
  'airline',
  'aerolinea',
  'aerolínea',
  'aerolineas',
  'aerolíneas',
  'mr',
  'mrs',
  'sr',
  'system',
  'pepe',
  'sistema',
  'sra',
  // Secuencias sin significado
  'a',
  'aa',
  'aaa',
  'aaaa',
  'aaaaa',
  'b',
  'bb',
  'bbb',
  'bbbb',
  'bbbbb',
  'ccc',
  'cccc',
  'ddd',
  'dddd',
  'abc',
  'abcd',
  'abcde',
  'xyz',
  'wxyz',
  'fgh',
  'fghjk',
  'qwerty',
  'qwert',
  'qwer',
  'asdf',
  'zxc',
  'zxcv',
  // Palabras funcionales u operativas
  'viaje',
  'viajes',
  'ida',
  'vuelta',
  'tramo',
  'tramos',
  'segmento',
  'segmentos',
  'ruta',
  'rutas',
  'grupo',
  'grupos',
  'familia',
  'familias',
  'empresa',
  'empresas',
  'corporativo',
  'corporativa',
  'staff',
  'equipo',
  'equipos',
  'oficina',
  'oficinas',
  'departamento',
  'sector',
  'area',
  'área',
  'backoffice',
  'back',
  'contabilidad',
  'ventas',
  'comercial',
  'soporte',
  'support',
  'help',
  'admin',
  'administracion',
  'administración',
  'sistemas',
  'operaciones',
  'operacion',
  'operación',
  // Términos colectivos genéricos
  'amigos',
  'amigo',
  'amigas',
  'pasajeros',
  'pasajero',
  'invitados',
  'invitado',
  'colaboradores',
  'colaborador',
  'asociados',
  'asociado',
  'delegacion',
  'delegación',
  'delegaciones',
  'familiar',
  'familiares',
  'participantes',
  'grupofamilia',
  'grupofamiliar',
  // Personajes ficticios
  'mickey',
  'mouse',
  'mickeymouse',
  'minnie',
  'donald',
  'duck',
  'donaldduck',
  'goofy',
  'pluto',
  'batman',
  'robin',
  'superman',
  'clarkkent',
  'brucewayne',
  'spiderman',
  'spider-man',
  'peterparker',
  'hulk',
  'thor',
  'loki',
  'harrypotter',
  'harry',
  'potter',
  'frodo',
  'gandalf',
  'dartvader',
  'darthvader',
  'vader',
  'skywalker',
  // Celebridades y figuras públicas
  'messi',
  'lionelmessi',
  'lionel',
  'ronaldo',
  'cristianoronaldo',
  'cr7',
  'neymar',
  'maradona',
  'diego',
  'madonna',
  'shakira',
  'beyonce',
  'rihanna',
  'taylor',
  'taylorswift',
  'swift',
  'bradpitt',
  'brad',
  'pitt',
  'tomcruise',
  'tom',
  'cruise',
  'leonardodicaprio',
  'dicaprio',
  'elonmusk',
  'elon',
  'musk',
  // Sobrenombres / apodos comunes
  'paco',
  'cacho',
  'fito',
  'chicho',
  'lolo',
  'tito',
  'nacho',
  'pancho',
  'pito',
  'facu',
  'pichi',
  'mari',
  'nene',
  'negro',
  'gordo',
  'flaco',
  'pelado',
  'colorado',
  'rulo',
  'rulito',
];
